import React, { useEffect, useRef, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import { API, useApp } from "../context/AppContext";
import { Reveal } from "../components/Reveal";

export default function PaymentResult() {
  const { result } = useParams();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clearCart } = useApp();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (result !== "success" || !sessionId) {
      setStatus(result === "cancel" ? "cancelled" : "checking");
      return;
    }
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          clearCart();
          return;
        }
      } catch {}
      attempts.current += 1;
      if (attempts.current < 10) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [result, sessionId]);

  return (
    <main className="pt-24 sm:pt-32" data-testid="payment-result-page">
      <section className="container-x section-y max-w-xl text-center">
        <Reveal>
          {status === "checking" && (
            <div data-testid="payment-checking">
              <Loader2 size={40} className="mx-auto animate-spin text-[#FF1A1A]" />
              <h1 className="h-section mt-8">Confirming Payment…</h1>
            </div>
          )}
          {status === "paid" && (
            <div data-testid="payment-success">
              <CheckCircle size={40} className="mx-auto text-[#FF1A1A]" />
              <h1 className="h-section mt-8">Welcome to the Collector Circle</h1>
              <p className="text-muted-foreground mt-4">Your order is confirmed. You'll receive details by email shortly.</p>
            </div>
          )}
          {status === "cancelled" && (
            <div data-testid="payment-cancelled">
              <XCircle size={40} className="mx-auto text-muted-foreground" />
              <h1 className="h-section mt-8">Checkout Cancelled</h1>
              <p className="text-muted-foreground mt-4">No charge was made. Your cart is still waiting for you.</p>
            </div>
          )}
          {status === "timeout" && (
            <div data-testid="payment-timeout">
              <Loader2 size={40} className="mx-auto text-[#B8860B]" />
              <h1 className="h-section mt-8">Still Processing</h1>
              <p className="text-muted-foreground mt-4">Payment is taking longer than expected to confirm. Check your email for confirmation.</p>
            </div>
          )}
          <div className="mt-10 flex justify-center gap-4">
            <Link to="/collect" className="btn-red" data-testid="payment-back-shop">Back to the Shop</Link>
            <Link to="/" className="btn-ghost" data-testid="payment-back-home">Home</Link>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
